/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ArrayFieldItemTemplateType,
  FormContextType,
  getTemplate,
  getUiOptions,
  RJSFSchema,
  StrictRJSFSchema,
} from '@rjsf/utils';

export function ShArrayFieldItemTemplate<
  T = any,
  S extends StrictRJSFSchema = RJSFSchema,
  F extends FormContextType = any,
>(props: ArrayFieldItemTemplateType<T, S, F>) {
  const { children, buttonsProps, hasToolbar, uiSchema, registry } = props;
  const uiOptions = getUiOptions<T, S, F>(uiSchema);
  const ArrayFieldItemButtonsTemplate = getTemplate<
    'ArrayFieldItemButtonsTemplate',
    T,
    S,
    F
  >('ArrayFieldItemButtonsTemplate', registry, uiOptions);
  return (
    <div>
      <div className="mb-2 flex flex-col">
        <div className="mb-2">{children}</div>
        {hasToolbar && (
          <div className="flex justify-end">
            <ArrayFieldItemButtonsTemplate {...buttonsProps} />
          </div>
        )}
      </div>
    </div>
  );
}
